import { render, staticRenderFns } from "./sayfaTanimla.vue?vue&type=template&id=cdf46520&"
import script from "./sayfaTanimla.vue?vue&type=script&lang=js&"
export * from "./sayfaTanimla.vue?vue&type=script&lang=js&"
import style0 from "./sayfaTanimla.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports